export default __webpack_public_path__ + "static/media/step-1-digital-update.6c99b825.jpg";